import { connect } from 'react-redux';
import type { WarningMessage } from 'state/quotes/results/result.model';
import { getQuoteResult } from 'state/quotes/results/results.selectors';
import type { AppState } from 'state/state.model';

const emptyWarnings: readonly [] = [];

export interface OwnProps {
  quoteId: string;
}

export interface StateProps {
  warningMessages: readonly WarningMessage[];
}

export type QuoteWarningState = StateProps & OwnProps;

const mapStateToProps = (state: AppState, { quoteId }: OwnProps): StateProps => {
  return {
    warningMessages: getQuoteResult(state.quotes.results, quoteId)?.warnings ?? emptyWarnings,
  };
};

export const connectQuoteWarning = connect(mapStateToProps);
